$(function () {

    const brandFilter = $(".brand__filter");

    brandFilter.find("span").on("click", function () {

        if ($(this).attr("id") === "brand-filter-prev") {
            brandFilter.find("ul").animate({
                scrollLeft: brandFilter.find("ul").scrollLeft() - 150
            }, 150)
        } else if ($(this).attr("id") === "brand-filter-next") {
            brandFilter.find("ul").animate({
                scrollLeft: brandFilter.find("ul").scrollLeft() + 150
            }, 150)
        }

        if (brandFilter.find("ul").scrollLeft() >= 100) {
            brandFilter.find("#brand-filter-prev").show();
        } else {
            brandFilter.find("#brand-filter-prev").hide();
        }
    
        if (brandFilter.find("ul").width() + brandFilter.find("ul").scrollLeft() >= brandFilter.find("ul")[0].scrollWidth) {
            brandFilter.find("#brand-filter-next").hide();
        } else {
            brandFilter.find("#brand-filter-next").show();
        }

    })

    brandFilter.find("ul li a").on("click", function () {
        const clickedIndex = $(this).index(".brand__filter ul li a");

        if (!$(".brand__filter ul li").eq(clickedIndex).hasClass("active")) {
            $(".brand__filter ul li.active").removeClass("active");
            $(".brand__filter ul li").eq(clickedIndex).addClass("active")
        }

        if ($(".brand__filter li").eq(clickedIndex).offset().left > $(".brand__filter ul").width() / 2) {
            brandFilter.find("ul").animate({
                scrollLeft: brandFilter.find("ul").scrollLeft() + 150
            }, 150)
        } else {
            brandFilter.find("ul").animate({
                scrollLeft: brandFilter.find("ul").scrollLeft() - 150
            }, 150)
        }

        if (brandFilter.find("ul").width() + brandFilter.find("ul").scrollLeft() >= brandFilter.find("ul")[0].scrollWidth) {
            brandFilter.find("#brand-filter-next").hide();
        } else {
            brandFilter.find("#brand-filter-next").show();
        }
    })

    $(".filter__box__toggle").on("click", function () {
        $(".card__filters__box").toggleClass("open")
    })
})